import Vuex from 'vuex';
import Vue from 'vue';
import createPersistedState from "vuex-persistedstate";
import auth from './modules/auth';
import i18n, { selectedLocale } from '@/plugins/i18n'

// Load Vuex
Vue.use(Vuex);
// Create store
export default new Vuex.Store({
    state: {
        locale: selectedLocale
    },
    mutations: {
        updateLocale(state, newLocale) {
            state.locale = newLocale
        }
    },
    actions: {
        changeLocale({ commit }, newLocale) {
            console.log(newLocale)
            i18n.locale = newLocale // important!
            commit('updateLocale', newLocale)
        }
    },
    modules: {
        auth
    },
    plugins: [createPersistedState()]
});
